import { render, staticRenderFns } from "./PresentationCategoryList.vue?vue&type=template&id=4ffc7969&"
import script from "./PresentationCategoryList.vue?vue&type=script&lang=js&"
export * from "./PresentationCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports